import { render, staticRenderFns } from "./ActivateCard.vue?vue&type=template&id=09b8d21a&"
import script from "./ActivateCard.vue?vue&type=script&lang=js&"
export * from "./ActivateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports